<template>
    <div class="hero-basic">
        <div
            v-if="hasMedia && !$slots.backlink"
            class="hero-basic__media"
        >
            <div class="hero-basic__media-wrapper">
                <ClientOnly v-if="video">
                    <LazyBaseVideo
                        :video="video"
                        :poster="image?.w380"
                        autoplay
                    />
                </ClientOnly>
                <ImageAsset
                    v-else-if="image"
                    :image="image"
                    sizes="100vw"
                    loading="eager"
                    fetch-priority="high"
                />
            </div>
        </div>
        <div class="hero-basic__content">
            <div>
                <BackLink v-if="!!$slots.backlink"><slot name="backlink" /></BackLink>
                <div
                    v-if="!!$slots.date"
                    class="hero-basic__date"
                >
                    <BaseIcon icon="event-dot" />
                    <slot name="date" />
                </div>

                <h1 class="hero-basic__title">{{ title }}</h1>
                <div
                    v-if="!!$slots.datesmall"
                    class="hero-basic__date-small"
                >
                    <slot name="datesmall" />
                </div>

                <!-- eslint-disable vue/no-v-html -->
                <div
                    v-if="description"
                    class="hero-basic__description article"
                    v-html="description"
                />
                <!-- eslint-enable -->
            </div>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    image: {
        type: Object,
        default: () => {}
    },
    video: {
        type: String,
        default: ''
    },
    title: {
        type: String,
        required: true
    },
    description: {
        type: String,
        default: ''
    }
});

const { image, video } = toRefs(props);
const hasMedia = computed(() => !!image.value || !!video.value);
</script>

<style lang="less" src="./HeroBasic.less" />
